var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_Allocate3"),
        width: "1000px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", [
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c("cargo-ag-grid", {
              staticStyle: {
                "margin-top": "10px",
                height: "400px",
                width: "500px"
              },
              attrs: {
                "config-module": "26000526",
                "grid-options": _vm.syncDialog.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.syncDialog.rowData,
                "grid-params": _vm.syncDialog.gridParams,
                "check-main-record": false,
                "deselect-main-record": false
              },
              on: {
                "update:gridParams": function($event) {
                  return _vm.$set(_vm.syncDialog, "gridParams", $event)
                },
                "update:grid-params": function($event) {
                  return _vm.$set(_vm.syncDialog, "gridParams", $event)
                },
                gridReady: function(params) {
                  return (_vm.syncDialog.gridApi = params.api)
                }
              }
            }),
            _c(
              "el-form",
              {
                staticStyle: {
                  width: "450px",
                  "padding-left": "20px",
                  "padding-right": "10px"
                },
                attrs: { "label-position": "left", "label-width": "70px" }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        attrs: { no: "1" },
                        model: {
                          value: _vm.form.type,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "type", $$v)
                          },
                          expression: "form.type"
                        }
                      },
                      [
                        _vm.$checkPermission([
                          "button_cabinManagement_AllocateCreateVerify"
                        ])
                          ? _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_CabinCreate1"))
                              )
                            ])
                          : _vm._e(),
                        _vm.$checkPermission([
                          "button_cabinManagement_AllocateCreateSEBooking"
                        ])
                          ? _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_CabinCreate2"))
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_AuthorizedClient"))
                        )
                      ]
                    ),
                    _c("cargo-sales-company-select", {
                      staticClass: "shipper-selector",
                      staticStyle: { flex: "1" },
                      attrs: {
                        no: "customerId",
                        "popper-class": "shipper-selector-popper",
                        "method-params": {
                          customer: true,
                          companyLob: "seaExport",
                          active: true
                        },
                        "check-credit": true,
                        "default-value": _vm.form.customerId || "",
                        job: _vm.form
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.form.customerId = p.value
                          _vm.loadCompanyUser()
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.SalesCompany")))]
                    ),
                    _c("el-input", {
                      attrs: { value: _vm.txtSalesOffice, disabled: true }
                    })
                  ],
                  1
                ),
                _c("el-form-item", [
                  _c(
                    "span",
                    {
                      staticClass: "blue",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "sales",
                        staticStyle: { flex: "1" },
                        attrs: {
                          no: "sales",
                          "method-params": {
                            officeId: _vm.salesOfficeCheck
                              ? _vm.$store.getters.currentOfficeId
                              : "",
                            category: "role",
                            shape: "sales"
                          },
                          "default-value": _vm.form.sales || "",
                          "static-options": _vm.salesList,
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.form.salesRecord = p.value
                            _vm.salesChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.SalesDepartment")))]
                    ),
                    _c("cargo-department-new-select", {
                      attrs: {
                        no: "salesOffice",
                        disabled: !_vm.form.sales,
                        "sales-id": Number(_vm.form.sales),
                        "office-id": _vm.form.salesOffice,
                        "department-id": Number(_vm.form.salesDepartment)
                      },
                      on: {
                        change: function(p) {
                          _vm.form.salesDepartment = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.OperationCompany") } },
                  [
                    _c("cargo-office-select", {
                      attrs: {
                        no: "opOffice",
                        disabled: true,
                        "office-id": Number(_vm.form.opOffice)
                      },
                      on: {
                        change: function(p) {
                          _vm.form.opOffice = p.value
                          _vm.form.opDepartment = 0
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.OperationDepartment")))]
                    ),
                    _c("cargo-department-select", {
                      attrs: {
                        no: "opDepartment",
                        "office-id": Number(_vm.form.opOffice),
                        "department-id": Number(_vm.form.opDepartment)
                      },
                      on: {
                        change: function(p) {
                          _vm.form.opDepartment = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Operation")))]
                    ),
                    _c("cargo-user-select", {
                      ref: "op",
                      attrs: {
                        no: "op",
                        "method-params": {
                          officeId: _vm.form.opOffice,
                          category: "role",
                          shape: "op"
                        },
                        "default-value": _vm.form.op || "",
                        "merge-load": true
                      },
                      on: {
                        change: function(p) {
                          _vm.form.op = p.value
                          _vm.txtOPChangeHandler(p)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Distribution")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }